import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// istanbul ignore next
const HighlightedTitle = ({ title, term }) => {
  const re = new RegExp(term, 'i');
  const match = title.match(re);
  const isMatched = Array.isArray(match) && match.length;
  const matchStart = isMatched && title.indexOf(match[0]);
  const matchEnd = isMatched && matchStart + match[0].length;

  return isMatched ? (
    <Fragment>
      {title.substring(0, matchStart)}
      <span className="search__result_highlight">
        {title.substring(matchStart, matchEnd)}
      </span>
      {title.substring(matchEnd)}
    </Fragment>
  ) : (
    null
  );
};

HighlightedTitle.propTypes = {
  title: PropTypes.string.isRequired,
  term: PropTypes.string.isRequired,
};

export default HighlightedTitle;
